var map = {
	"./Symbol_0.png": 49172,
	"./Symbol_1.png": 65853,
	"./Symbol_2.png": 84646,
	"./Symbol_3.png": 23663,
	"./Symbol_4.png": 27792,
	"./Symbol_5.png": 56422,
	"./Symbol_6.png": 77954,
	"./Symbol_7.png": 99083,
	"./Symbol_8.png": 89596,
	"./Symbol_9.png": 72485
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14287;